import { getEnvironmentIdentifier } from "@maersk/shared-js";

/**
 * @name getEnvironmentVariables
 * @description Checks the current client environment and returns an object containing some environment-specific values.
 * @return {Object} An object containing environment-specific
 */
export function getEnvironmentVariables() {
  const environment = {};
  let subdomain = getEnvironmentIdentifier();
  switch (subdomain) {
    case "gcdagent-dev":
    case "gcdagentdev":
      environment.label = "dev";
      break;
    case "gcd-qa":
    case "gcdagentqa":
      environment.label = "qa";
      break;
    case "gcd-preprod":
    case "gcdagentpreprod":
      environment.label = "preprod";
      break;
    case "gcd-perf":
    case "gcdagentperf":
      environment.label = "perf";
      break;
    case "gcd":
    case "gcdagent":
      environment.label = "prod";
      break;
    case (subdomain.match(/^localhost/) || {}).input:
    default:
      environment.label = "localhost";
  }
  return environment;
}
